import bannerImg from './banners/woman-helping-man-gym.jpg';

const leadCoachingFitness = (t) => ({
    id: 'lead-coaching-fitness',
    title: t('templates.items.leadCoachingFitness.title'),
    description: t('templates.items.leadCoachingFitness.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.leadCoachingFitness.summary.nameAndContact'),
        t('templates.items.leadCoachingFitness.summary.commitmentLevel'),
        t('templates.items.leadCoachingFitness.summary.previousInvestment'),
        t('templates.items.leadCoachingFitness.summary.biggestChallenge'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.leadCoachingFitness.form.title'),
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.leadCoachingFitness.form.about.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.leadCoachingFitness.form.about.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'full_name',
                        label: t('templates.items.leadCoachingFitness.form.about.fullName.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'email',
                        label: t('templates.items.leadCoachingFitness.form.about.email.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'phone',
                        label: t('templates.items.leadCoachingFitness.form.about.whatsapp.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: t('templates.items.leadCoachingFitness.form.about.biggestChallenge.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 5,
                        type: 'yes_no_maybe',
                        label: t('templates.items.leadCoachingFitness.form.about.previousInvestment.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 6,
                        type: 'scale',
                        label: t('templates.items.leadCoachingFitness.form.about.commitment.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.leadCoachingFitness.form.about.commitment.minLabel'),
                            maxLabel: t('templates.items.leadCoachingFitness.form.about.commitment.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default leadCoachingFitness;
